import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbItem {
    label: string;
    href: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
    return (
        <nav className="flex items-center text-sm text-muted-foreground mb-8 overflow-x-auto whitespace-nowrap pb-2 md:pb-0">
            <Link to="/" className="hover:text-primary transition-colors flex items-center">
                <Home size={14} className="mr-1" /> Home
            </Link>
            {items.map((item, index) => (
                <React.Fragment key={item.href}>
                    <ChevronRight size={14} className="mx-2 text-muted-foreground/50 shrink-0" />
                    <Link 
                        to={item.href} 
                        className={`transition-colors ${index === items.length - 1 ? 'font-semibold text-foreground pointer-events-none' : 'hover:text-primary'}`}
                    >
                        {item.label}
                    </Link>
                </React.Fragment>
            ))}
        </nav>
    );
};
